import React from 'react';
import { Box } from '@material-ui/core';
import PrivateRoute from '../../auth/Routes/PrivateRoute';
import { Switch } from 'react-router-dom';
import useScopes from '../../hooks/useScopes';
import { useSelector } from 'react-redux';
import PartialRolloutScreen from './PartialRollout/PartialRolloutScreen';
import LaunchScreen from './Launch/LaunchScreen';
import {
  FEATURED_SCHOOL_MODULE_ROUTE,
  LAUNCH_MODULE_ROUTE,
  PARTIAL_ROLLOUT_MODULE_ROUTE,
} from '../../routes/routes';
import FeaturedSchoolScreen from './FeaturedSchool/FeaturedSchoolScreen';

const DoNotHaveAccess = () => {
  return (
    <Box
      fontFamily={'Rubik'}
      width={'100%'}
      minHeight={400}
      display="flex"
      justifyContent={'center'}
      alignItems="center">
      <Box maxWidth={500} fontSize={16} textAlign={'center'}>
        <Box mb={1}>You do not have access to this feature</Box>
        <Box fontSize={12}>
          NOTE: You are seeing this screen because you did not complete your KYC
          or you do not have permission to view this screen or You are not a
          PLATINUM member
        </Box>
      </Box>
    </Box>
  );
};

function LaunchManagementScreen() {
  const { access } = useScopes();

  const { moduleAccess } = useSelector(({ signInReducer }) => {
    return {
      moduleAccess: signInReducer.me
        ? signInReducer.me.data
          ? signInReducer.me.data.role
          : []
        : [],
    };
  });

  return (
    <Box>
      <Switch>
        <PrivateRoute
          exact
          path={[PARTIAL_ROLLOUT_MODULE_ROUTE]}
          component={
            moduleAccess.includes('bccSuperAdmin') ||
            access({
              mode: 'allOf',
              scope: ['partialRollout: readWrite'],
            })
              ? PartialRolloutScreen
              : DoNotHaveAccess
          }
        />
        <PrivateRoute
          exact
          path={LAUNCH_MODULE_ROUTE}
          component={
            moduleAccess.includes('bccSuperAdmin') ||
            access({
              mode: 'allOf',
              scope: ['approval:discovery:readWrite'],
            })
              ? LaunchScreen
              : DoNotHaveAccess
          }
        />
        <PrivateRoute
          exact
          path={FEATURED_SCHOOL_MODULE_ROUTE}
          component={
            moduleAccess.includes('bccSuperAdmin') ||
            access({
              mode: 'allOf',
              scope: ['approval:management:readWrite'],
            })
              ? FeaturedSchoolScreen
              : DoNotHaveAccess
          }
        />
      </Switch>
    </Box>
  );
}

export default LaunchManagementScreen;
